export default {
      id: "ic-dropdown-chevron-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-dropdown-chevron-usage",
      toString: function () {
        return this.url;
      }
    }